import { Connector } from '@appTypes/resources/team';
import { ConnectorTypeEnum } from '@constants/enums/ConnectorType.enum';

const CONNECTOR_TYPES = Object.values(ConnectorTypeEnum);

// `Team.connectors` mixes every integration, so the type decides which section
// a connector belongs to. Connectors created before the Shopify integration
// carry no type and are always Facebook ones.
export const getConnectorType = (connector: Connector): ConnectorTypeEnum => {
  const type = connector.type?.toLowerCase() as ConnectorTypeEnum | undefined;

  return type && CONNECTOR_TYPES.includes(type)
    ? type
    : ConnectorTypeEnum.FACEBOOK;
};
